import * as Joi from "joi";
import { Column, Entity, PrimaryGeneratedColumn, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';

import Base from '../base.entity';
import CmStatus from '../cm-statuses/cm-status.entity';
import PropStatus from '../prop-statuses/prop-status.entity';
import SetPieceStatus from '../set-piece-statuses/set-piece-status.entity';

@Entity('prop_status_colors')
export default class PropStatusColor extends Base {
	@PrimaryGeneratedColumn()
	id: number;

	@Column('varchar')
	value: string;

	@OneToMany((type) => CmStatus, (cmStatus) => cmStatus.cmStatusColor)
	cmStatuses: CmStatus[];

	@OneToMany((type) => PropStatus, (propStatus) => propStatus.propStatusColor)
	propStatuses: PropStatus[];

	@OneToMany(
		(type) => SetPieceStatus,
		(setPieceStatus) => setPieceStatus.setPieceStatusColor
	)
	setPieceStatuses: SetPieceStatus[];

	static rules() {
		return {
			id: Joi.number().integer(),
			value: Joi.string().max(255),
		};
	}

	toJSON() {
		return {
			id: this.id,
			value: this.value,
		};
	}

	constructor(props?: GenPartial<PropStatusColor>) {
		super(props);
	}
}
